/* import __COLOCATED_TEMPLATE__ from './metric-card.hbs.js'; */
import Component from '@glimmer/component';
// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class MetricCard extends Component {}